import React, {Component, useEffect, useState} from 'react';
import {useNavigate, useLoaderData, useLocation} from 'react-router-dom';
import {RouteComponentProps} from '~utils/withRouter';
import styles from './styles.module.scss';
import {Route} from '~services/RoutesService';
// import actions from "~redux/Routes/actions";
import {COUNTRIES} from "~components/CountrySelect/constants";
import MapToggle from '~components/MapToggle';
import {Map} from './components/Map';
import {ElementHelper, MapList} from './components/MapList';
import {Project} from "~screens/Dashboard/screens/Projects/types";
import {useParams} from "react-router";

const ElementsMap = ({listPath, listTitle, dataLoader, routeDataLoader, selectable}: {
    listPath: (string | ((params: any) => Promise<string>)),
    listTitle?: (string | ((params: any) => Promise<string>)),
    dataLoader: (params, location) => Promise<(Route | Project)[]>,
    routeDataLoader?: (params, location) => Promise<Route | undefined>,
    selectable?: boolean
}) => {
    const [state, setState] = useState<{
        elements: (Route | Project)[],
        hoveredId?: number | string,
        listPath: string,
        listTitle: string,
        route?: Route
    }>({
        elements: [],
        hoveredId: undefined,
        listPath: '',
        listTitle: ''
    });
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    useEffect(() => {
        const dataPromise = dataLoader(params, location);
        const listPathPromise = typeof listPath !== 'string' ? listPath(params) : new Promise<string>((resolve) => {
            resolve(listPath)
        });
        const listTitlePromise = listTitle === undefined ? '' : (typeof listTitle !== 'string' ? listTitle(params) : new Promise<string>((resolve) => {
            resolve(listTitle)
        }));
        const routeDataPromise = routeDataLoader ? routeDataLoader(params, location) : new Promise<Route | undefined>((resolve) => {
            resolve(undefined);
        });

        // Await all four promises and then update state
        Promise.all([dataPromise, listPathPromise, listTitlePromise, routeDataPromise]).then(value => {
            const [elements, listPath, listTitle, route] = value;
            setState({...state, elements, listPath, listTitle, route});
        })
    }, [params]);


    const onHover = (id) => {
        setState({...state, hoveredId: id});
    }

    const onLeave = () => {
        setState({...state, hoveredId: undefined});
    }

    const onGoto = (id: number | string) => {
        const {elements} = state;
        const [first, ...rest] = elements;
        if (ElementHelper.isProject(first)) {
            navigate(`/projects/${id}/show`);
        }
        if (ElementHelper.isRoute(first)) {
            navigate(`/routes/${id}/show/map`);
        }
    }

    const {elements, hoveredId} = state;

    const {listPath: resolvedListPath, listTitle: resolvedListTitle, route} = state;

    return (
        <div className={styles.container}>
            <div className={styles.leftColumn}>
                <MapList elements={elements} onHover={onHover} onLeave={onLeave} onGoto={onGoto}
                         listTitle={resolvedListTitle}/>
            </div>
            <div className={styles.rightColumn}>
                <MapToggle listPath={resolvedListPath} />
                <Map elements={elements} hoveredId={hoveredId} route={route} selectable={selectable}/>
            </div>
        </div>
    );
}

// const mapStateToProps = state => {
//     return {
//         hoveredId: state.routes.hoveredId,
//         // projectDetail: state.iirsaProjectDetail.iirsaProjectDetail,
//         // loading: state.iirsaProjectDetail.iirsaProjectDetailLoading
//     }
// };
//
// const mapDispatchToProps = dispatch => ({
//     onHover: id => dispatch(actions.setHoveredRouteId(id)),
//     onLeave: () => dispatch(actions.setHoveredRouteId(null)),
//     dispatchFn: dispatch
// });

export default ElementsMap;
